import React from "react";

interface SvgProps {
  color?: string;
}

export const StickSvg: React.FC<SvgProps> = ({ color = "white" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.6573 11.5817V19.1111H8.87953V11.5817H6.6573ZM7.76841 10.4706H4.39999V12.6928H7.76841V10.4706ZM6.6573 4.88892V8.23532H8.87953V4.88892H6.6573ZM6.6573 8.23532V11.5817H8.87953V8.23532H6.6573ZM7.76841 9.34643H11.5579V7.12421H7.76841V9.34643ZM15.4994 12.4183V17.0196H17.7216V12.4183H15.4994ZM16.6105 11.3072H13.6632V13.5294H16.6105V11.3072ZM15.4994 4.88892V6.00003H17.7216V4.88892H15.4994ZM15.4994 6.00003V12.4183H17.7216V6.00003H15.4994ZM16.6105 7.11114H20.4V4.88892H16.6105V7.11114Z"></path>
    </svg>
  );
};
